import httpService from "app/services/httpService";
import config from "../../../src/config.json";

const apiUrl = config.apiUrl; // Assuming the apiUrl is defined in config.json.
const buildDashboardRequest = (filters) => {
  const payload = {
    timeFilter: filters.timeFilter,
    journeyType: filters.journeyType,
    airlineCode: filters.airlineCode === "all" ? null : filters.airlineCode,
    chartType: filters.chartType,
  };

  if (filters.timeFilter === "particularDate" && filters.particularDate) {
    payload.particularDate = filters.particularDate; // yyyy-MM-dd
  }
  if (filters.timeFilter === "dateRange") {
    if (filters.fromDate) payload.fromDate = filters.fromDate;
    if (filters.toDate) payload.toDate = filters.toDate;
  }
  return payload;
};
const getDashboardSummary = async (filters, signal) => {
  const body = buildDashboardRequest(filters);
  const { data } = await httpService.post(`${apiUrl}/dashboard/summary`, body, {
    signal,
  });
  return data;
};

/**
 * GET list of airlines for the airline filter dropdown.
 * Server endpoint: GET /api/dashboard/airlines
 */
const getAirlines = async (signal) => {
  const { data } = await httpService.get(`${apiUrl}/dashboard/airlines`, {
    signal,
  });
  return data;
};
export { getDashboardSummary, getAirlines };
